module.exports = __webpack_public_path__ + "img/etesting-logo.b18815d9.png";